export const summaryRows: string[] = [
  'Volume 1 — ENSO Fundamentals & Forecast Reading',
  'Volume 2 — Global Impact Map by Region & Sector',
  'Volume 3 — Flood, Drainage & Water Management for Industrial Sites',
  'Volume 4 — Heat, Drought & Energy Supply Risk',
  'Volume 5 — Operational Continuity by Industry',
  'Volume 6 — Risk Assessment, Emergency Response & Monitoring',
  'Bonus 1 — El Niño Site Readiness Checklist',
  'Bonus 2 — Extreme Weather Emergency Response Quick Guide',
  'Bonus 3 — Climate Risk & ENSO Technical Glossary',
  'Bonus 4 — Heat Stress Field Card for Workers',
  'Bonus 5 — Early Warning Indicators Cheat Sheet',
  '7-day money-back guarantee',
  'Instant access',
];
